import { appShadowRoot } from '../../common/elements';
import { LastInvalidRoute, LastRoute, Route } from '../../common/keys';
import { log } from '../../common/log';
import { o } from '../../common/observable';
import { support } from '../support';

export const newAccount = location.search.includes('newAccount=true');

export const defaults = {
  home: '',
  recommended: 'solutions',
  dashboard: 'learning',
};

export function defaultd(arg = '') {
  const args = arg.split('/');
  let result = arg;
  let last = args.length > 1 ? args[args.length - 1] : '' || '';

  if (last.length > 0) {
    while (last in defaults) {
      last = defaults[last];
      result = `${result}/${last}`;
    }
  }

  return result;
}

export function process(arg = '') {
  const args = arg.split('/');
  const prevUrl = adobeDataLayer
    .filter((i) => 'event' in i && i.event === 'page loaded')
    .reduce((a, v) => v.web.webPageDetails.URL, '');
  let track = true;
  let dispatched = false;

  if (args[0] !== 'home' && window.ino !== void 0) {
    window.ino.disconnect();
    log('Disconnected Slider intersection listener');
  }

  if (args[0] === 'home') {
    support();
  } else if (args[0] === 'support') {
    track = false;
    dispatched = true;
    support().catch(() => log('Something went wrong in support()'));
  }
}

async function callback(arg) {
  const seg = arg.hash.split('/');
  const id = seg[seg.length - 1];
  const target = appShadowRoot.querySelector(`#${id}`) === null ? seg.pop() : null;
  const newHash = defaultd(arg.hash);

  if (seg.length > 1 && seg[1].length > 0) {
    defaults[seg[0]] = seg[1];

    if (seg[1] !== id) {
      defaults[seg[1]] = id;
    }
  }

  if (target !== null) {
    log(`Route constructor: ${target}`);
  }

  if (newHash === arg.hash) {
    const current = sessionStorage.getItem(Route);

    if (current !== null && current !== LastInvalidRoute && sessionStorage.getItem(LastRoute) !== current) {
      sessionStorage.setItem(LastRoute, current);
    }

    sessionStorage.setItem(Route, arg.hash);
    process(arg.hash);
  } else {
    history.replaceState({}, '', `#${newHash}`);
  }
}

export const first = Reflect.ownKeys(defaults)[0];

export const config = {
  active: true,
  callback,
  start: defaultd(sessionStorage.getItem(Route) || first),
};
